import React from 'react'

import { ReporterBase } from '@/types'

type StipulationProps = {
  reporter: ReporterBase | null
}

export const Stipulation: React.FC<StipulationProps> = ({ reporter }) => {
  if (
    reporter?.state &&
    ['MS', 'OH', 'MD', 'UT', 'VA'].includes(reporter.state)
  ) {
    return (
      <>
        Do all parties stipulate to me conducting this oath and affirmation
        remotely, in the role as a Digital Reporter, understanding we are not
        physically present with each other and may be located in different
        jurisdictions?
      </>
    )
  }

  return (
    <>
      Do all parties stipulate to me conducting this oath and affirmation
      remotely, understanding we are not physically present with each other and
      may be located in different jurisdictions?
    </>
  )
}
